import { Card } from 'antd';
import { BackButton } from '../../uiComponents/BackButton';
import { useParams } from 'react-router-dom';
import { UrlPaths } from '../../../constants';
import { consignOrderRefundConst } from '../../../constants/ConsignOrderRefund.const';
import { ConsignmentOrderRefundForm } from '../../components/ConsignmentOrderRefund/ConsignmentOrderRefundForm';

export const ConsignOrderRefunds = () => {
  const { id, numberOrder, consignmentOrderRefundId } = useParams();

  return (
    <Card
      title={
        <BackButton
          path={UrlPaths.CONSIGNMENT_ORDER_REFUND(id, numberOrder)}
          label={
            consignmentOrderRefundId
              ? consignOrderRefundConst.edit
              : consignOrderRefundConst.create
          }
        />
      }
      bordered={true}
      className="gx-card"
    >
      <ConsignmentOrderRefundForm
        consignmentOrderId={id}
        numberOrder={numberOrder}
        consignmentOrderRefundId={consignmentOrderRefundId}
      />
    </Card>
  );
};
